import React, { useEffect } from "react";
export const CustomFields = ({
  fields,
  values,
  onChange,
  disabled = false,
}) => {
  useEffect(() => {
    console.log("🔧 CustomFields - Props recibidas:", {
      fields,
      fieldsCount: fields?.length || 0,
      fieldsIsArray: Array.isArray(fields),
      values,
      disabled,
    });
  }, [fields, values, disabled]);

  if (!fields || fields.length === 0) {
    return null;
  }

  console.log("✅ CustomFields - Renderizando", fields.length, "campos");

  const handleChange = (fieldName, value) => {
    console.log("📝 Campo modificado:", fieldName, "=", value);
    onChange({ ...values, [fieldName]: value });
  };

  const renderField = (field) => {
    const value = values?.[field.name] || "";

    switch (field.type) {
      case "text":
        return (
          <div key={field.name} className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {field.label}
              {field.required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <input
              type="text"
              value={value}
              onChange={(e) => handleChange(field.name, e.target.value)}
              disabled={disabled}
              placeholder={field.placeholder || ""}
              required={field.required}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all disabled:bg-gray-100"
            />
          </div>
        );

      case "number":
        return (
          <div key={field.name} className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {field.label}
              {field.required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <input
              type="number"
              value={value}
              onChange={(e) => handleChange(field.name, e.target.value)}
              disabled={disabled}
              placeholder={field.placeholder || ""}
              required={field.required}
              min={field.min}
              max={field.max}
              step={field.step || "1"}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all disabled:bg-gray-100"
            />
          </div>
        );

      case "date":
        return (
          <div key={field.name} className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {field.label}
              {field.required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <input
              type="date"
              value={value}
              onChange={(e) => handleChange(field.name, e.target.value)}
              disabled={disabled}
              required={field.required}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all disabled:bg-gray-100"
            />
          </div>
        );

      case "select":
        return (
          <div key={field.name} className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {field.label}
              {field.required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <select
              value={value}
              onChange={(e) => handleChange(field.name, e.target.value)}
              disabled={disabled}
              required={field.required}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all disabled:bg-gray-100"
            >
              <option value="">-- Seleccione --</option>
              {field.options?.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        );

      case "multiselect":
        return (
          <div key={field.name} className="col-span-1">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {field.label}
              {field.required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className="space-y-2 max-h-40 overflow-y-auto border-2 border-gray-300 rounded-lg p-3">
              {field.options?.map((option) => (
                <label
                  key={option.value}
                  className="flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded transition-colors"
                >
                  <input
                    type="checkbox"
                    checked={(value || []).includes(option.value)}
                    onChange={(e) => {
                      const currentValues = value || [];
                      const newValues = e.target.checked
                        ? [...currentValues, option.value]
                        : currentValues.filter((v) => v !== option.value);
                      handleChange(field.name, newValues);
                    }}
                    disabled={disabled}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-sm text-gray-700">
                    {option.label}
                  </span>
                </label>
              ))}
            </div>
          </div>
        );

      case "textarea":
        return (
          <div key={field.name} className="col-span-full">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {field.label}
              {field.required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <textarea
              value={value}
              onChange={(e) => handleChange(field.name, e.target.value)}
              disabled={disabled}
              placeholder={field.placeholder || ""}
              required={field.required}
              rows={field.rows || 3}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all disabled:bg-gray-100"
            />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="border-t-2 border-gray-200 pt-5 mt-5">
      <h3 className="text-md font-bold text-gray-900 mb-4">
        📋 Información Adicional
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields.map((field) => renderField(field))}
      </div>
    </div>
  );
};
